import { Composition, continueRender, delayRender } from "remotion";
import { getAvailableFonts } from "@remotion/google-fonts";
import { InstagramPost } from "./InstagramPost";
import { InstagramStory } from "./InstagramStory";
import { LinkedInBanner } from "./LinkedInBanner";
import { YouTubeThumbnail } from "./YouTubeThumbnail";
import { TwitterCard } from "./TwitterCard";
import { ReelsTikTok } from "./ReelsTikTok";
import { Carrossel } from "./Carrossel";
import { Depoimento } from "./Depoimento";
import { AnaliseCorporal3D } from "./AnaliseCorporal3D";

const fontLoadHandle = delayRender();

const fontWeights: Record<string, { weights: string[]; subsets: string[] }> = {
  "Playfair Display": { weights: ["400", "500", "600", "700", "900"], subsets: ["latin"] },
  Inter: { weights: ["300", "400", "500", "600", "700"], subsets: ["latin"] },
};

const fontEntries = getAvailableFonts().filter((f) =>
  Object.keys(fontWeights).includes(f.fontFamily)
);

Promise.all(
  fontEntries.map(async (entry) => {
    const mod = await entry.load();
    mod.loadFont(undefined, fontWeights[entry.fontFamily]);
  })
).then(() => continueRender(fontLoadHandle));

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition
        id="InstagramPost"
        component={InstagramPost}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1080}
        defaultProps={{
          headline: "O CORPO EXPLICA",
          body: "Descubra como suas dores e tensões contam uma história que nenhum exame revela.",
          cta: "Agende sua análise",
        }}
      />
      <Composition
        id="InstagramStory"
        component={InstagramStory}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          headline: "O CORPO EXPLICA",
          subheadline: "Analista Corporal",
          cta: "Agende sua análise",
        }}
      />
      <Composition
        id="LinkedInBanner"
        component={LinkedInBanner}
        durationInFrames={1}
        fps={30}
        width={1584}
        height={396}
        defaultProps={{
          mainText: "Analista Corporal",
          subText: "Edson Santoro — O Corpo Explica",
          cta: "Agende sua análise",
        }}
      />
      <Composition
        id="YouTubeThumbnail"
        component={YouTubeThumbnail}
        durationInFrames={1}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{
          title: "O CORPO EXPLICA",
          number: "01",
          tag: "ANÁLISE",
          subtitle: "O que suas dores revelam",
        }}
      />
      <Composition
        id="TwitterCard"
        component={TwitterCard}
        durationInFrames={1}
        fps={30}
        width={1200}
        height={675}
        defaultProps={{
          headline: "O Corpo Explica",
          body: "Suas dores e tensões contam uma história que nenhum exame revela. Descubra o que seu corpo está dizendo.",
          author: "Edson Santoro",
          role: "Analista Corporal",
        }}
      />
      <Composition
        id="ReelsTikTok"
        component={ReelsTikTok}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          hookText: "VOCÊ SABIA?",
          mainText: "Suas dores emocionais se manifestam no corpo.",
          revealText: "O Corpo Explica tudo.",
          cta: "Agende sua análise",
        }}
      />
      <Composition
        id="Carrossel"
        component={Carrossel}
        durationInFrames={1}
        fps={30}
        width={1080}
        height={1080}
        defaultProps={{
          title: "O CORPO EXPLICA",
          badge: "GUIA RÁPIDO",
          cta: "Deslize para ver mais",
        }}
      />
      <Composition
        id="Depoimento"
        component={Depoimento}
        durationInFrames={1}
        fps={30}
        width={1080}
        height={1080}
        defaultProps={{
          quote: "Depois da sessão, entendi que minha dor nas costas não era física. Era a vida que eu estava carregando.",
          author: "Maria Clara",
          detail: "Paciente — 3 sessões",
          rating: 5,
        }}
      />
      <Composition
        id="AnaliseCorporal3DPost"
        component={AnaliseCorporal3D}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1080}
        defaultProps={{
          headline: "Sua mente molda seu corpo",
          subheadline: "O formato das suas partes corporais revela a lógica do seu funcionamento mental inconsciente. Pare de lutar contra si mesmo.",
          ctaText: "Ver meu Mapa",
        }}
      />
      <Composition
        id="AnaliseCorporal3DStory"
        component={AnaliseCorporal3D}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          headline: "Sua mente molda seu corpo",
          subheadline: "O formato do corpo revela a lógica da mente.",
          ctaText: "Ver meu Mapa",
        }}
      />
    </>
  );
};
